var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 54,
    viewBox: "0 0 68 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 53.6693V46.1693H7.83073V5.33594C7.83073 4.0026 8.33073 2.83594 9.33073 1.83594C10.3307 0.835937 11.4974 0.335938 12.8307 0.335938H64.4974V5.33594H12.8307V46.1693H32.3307V53.6693H0.664062ZM40.5807 53.6693C39.6918 53.6693 38.928 53.3359 38.2891 52.6693C37.6502 52.0026 37.3307 51.1137 37.3307 50.0026V13.5859C37.3307 12.697 37.6502 11.9332 38.2891 11.2943C38.928 10.6554 39.6918 10.3359 40.5807 10.3359H63.2474C64.3585 10.3359 65.3168 10.6554 66.1224 11.2943C66.928 11.9332 67.3307 12.697 67.3307 13.5859V50.0026C67.3307 51.1137 66.928 52.0026 66.1224 52.6693C65.3168 53.3359 64.3585 53.6693 63.2474 53.6693H40.5807ZM42.3307 46.1693H62.3307V15.3359H42.3307V46.1693Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.acf8b4ac.svg";
export { ForwardRef as ReactComponent };